import { CustomBadge } from "@/components/ui/custom-badge";
import { getUserProfileBackgroundColor, getUserProfileColor } from "@/helper/colors/user-profiles";

export const UserProfileBadge = ({ userProfile, className }: { userProfile: string; className?: string }) => {
  const backgroundColor = getUserProfileBackgroundColor(userProfile);
  const textColor = getUserProfileColor(userProfile);
  return (
    <CustomBadge text={userProfile} backgroundColor={backgroundColor} textColor={textColor} className={className} />
  );
};
